/**
 * Relevant possible values for validation Tag of ResearchStudy
 */
export enum ValidationTagValue {
  InProcess = 'in-process',
  Validated = 'validated',
  ReqRevalid = 'req-revalid',
}
